module.exports = __webpack_public_path__ + "img/not-found.2c7712ee.png";